import * as React from 'react'

function SvgIconSoundMid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="sound-mid" aria-labelledby="t-sound-mid d-sound-mid">
        <title id="t-sound-mid">{'Medium sound'}</title>
        <desc id="d-sound-mid">{'A loudspeaker with two sound waves'}</desc>
        <path d="M14 7v18l-6-6H1v-6h7l6-6m0-1c-.3 0-.5.1-.7.3L7.6 12H1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6.6l5.7 5.7c.2.2.4.3.7.3.1 0 .3 0 .4-.1.4-.2.6-.5.6-.9V7c0-.4-.2-.8-.6-.9-.1-.1-.3-.1-.4-.1zm9.4 17.9c-.104 0-.301 0-.4-.104-.2-.196-.2-.5 0-.696 3.9-3.9 3.9-10.2 0-14.1-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0 4.3 4.3 4.3 11.3 0 15.601h-.3V23.9zm-3.5-3.5c-.104 0-.301 0-.4-.104-.2-.196-.2-.5 0-.696.9-.9 1.5-2.2 1.5-3.5s-.5-2.6-1.5-3.5c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0 1.1 1.1 1.8 2.6 1.8 4.2s-.6 3.1-1.8 4.2c-.1 0-.2.1-.3.1z" />
      </g>
    </svg>
  )
}

export default SvgIconSoundMid
